import cn from 'classnames'
import React from 'react'
import { Icon as BaseIcon, IconProps } from '../icon'

export function Icon({ className, ...props }: IconProps) {
  return (
    <BaseIcon
      className={cn('uds-button-icon', className)}
      {...props}
    />
  )
}
